let dssEventTypes = [
  // docSigner
  'DocSigner list requested',
  'DocSigner created',
  'DocSigner requested',
  'DocSigner updated',
  'DocSigner deleted'
]

export default dssEventTypes
